import { render, staticRenderFns } from "./editor-content.vue?vue&type=template&id=4aad0160&scoped=true&"
import script from "./editor-content.vue?vue&type=script&lang=js&"
export * from "./editor-content.vue?vue&type=script&lang=js&"
import style0 from "./editor-content.vue?vue&type=style&index=0&id=4aad0160&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad0160",
  null
  
)

export default component.exports